/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

export function DashboardPage() {
    return (
        <div className="p-6">
            <h1 className="text-3xl font-bold mb-4">Dashboard</h1>
            <p className="text-muted-foreground">
                Vítejte v Menyxo! Dashboard s widgety bude implementován později.
            </p>
        </div>
    )
}
